<script>
  let title = '';
  export let message = '';
  export let type = false; 
  export let show = false;
  let icon = '';
  let color = '';
  let timer;

  // Configuración reactiva para el icono, color y título
  $: {
    if (type) {  // Si 'type' es true (éxito)
      icon = '✔️';
      color = '#7be37f';
      title = 'SUCCESS';
    } else {  // Si 'type' es false (error)
      icon = '❌';
      color = '#f26161';
      title = 'ERROR';
    }
  }

  const hideToast = () => {
    show = false;
    clearTimeout(timer);
  };

  $: if (show) {
    timer = setTimeout(hideToast, 4000);  // Temporizador de 4 segundos
  }
</script>

<style>
  .toaster {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 10px 20px;
    background-color: var(--toast-color);
    color: white;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    transition: opacity 0.3s ease-in-out;
    z-index: 9999;
  }
  
  .toaster.hidden {
    opacity: 0;
    pointer-events: none;
  }

  .toaster .icon {
    margin-right: 10px;
  }

  .toaster .title {
    font-weight: bold;
    margin-right: 10px;
  }

  .toaster .message {
    flex: 1;
  }
</style>

<div 
  class="toaster {show ? '' : 'hidden'}" 
  style="--toast-color: {color};"
>
  <span class="icon">{icon}</span>
  <div>
    <div class="title">{title}</div>
    <div class="message">{message}</div>
  </div>
</div>
